import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as invoiceActions from "../../../../actions/invoice.actions";
import * as adminActions from "../../../../actions/admin.actions";

import Invoices from "../components/Invoices";

import parseAdvancedSearch from "../../../../utils/parseAdvancedSearch";
import parseFilters from "../../../../utils/parseFilters";
import {
  decodeSearchParams,
  getFinalQueryString
} from "../../../../utils/parseQueries";

class InvoicesContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      advancedSearch: [],
      filters: []
    };

    this.downloadInvoice = this.downloadInvoice.bind(this);
  }

  componentWillMount() {
    this.setState({ ...decodeSearchParams(this.props.location.search) });
  }

  componentDidMount() {
    const filters = getFinalQueryString(
      parseFilters(this.state.filters) +
        parseAdvancedSearch(this.state.advancedSearch)
    );

    this.props.invoiceActions.getAdminInvoices(filters);
    this.props.invoiceActions.getAdminInvoicesCSVData(filters);
  }

  downloadInvoice(invoiceId) {
    this.props.invoiceActions.downloadInvoice(invoiceId);
  }

  render() {
    return (
      <Invoices
        advancedSearch={this.state.advancedSearch}
        downloadInvoice={this.downloadInvoice}
        filters={this.state.filters}
        getCsvData={this.props.invoiceActions.getAdminInvoicesCSVData}
        getTable={this.props.invoiceActions.getAdminInvoices}
        history={this.props.history}
        invoices={this.props.invoices.data || []}
        invoices_csv={_.get(this.props, "invoices_csv.data") || []}
        loading={this.props.loading}
        numberOfPages={this.props.invoices.last_page}
        page={this.props.page}
        paginationCount={this.props.paginationCount}
        setPage={this.props.adminActions.setPage}
        setSort={this.props.adminActions.setSort}
        sortData={this.props.sortData}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    invoices: state.invoice.invoices,
    invoices_csv: state.invoice.invoices_csv,
    loading: state.company.loadingGetCompanies,
    page: state.admin.pagination.invoices,
    paginationCount: adminActions.getPaginationCounts(state.admin.pagination),
    sortData: state.admin.sorting.invoices
  };
};

const mapDispatchToProps = dispatch => {
  return {
    adminActions: bindActionCreators(adminActions, dispatch),
    invoiceActions: bindActionCreators(invoiceActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InvoicesContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/invoices/containers/InvoicesContainer.js